export default __webpack_public_path__ + "static/media/edenred.0cd98511.svg";